/**
 * Throws PERMISSION_DENIED if the auth context is missing the required
 * scope. Lifted 1:1 from provisioning's
 * `server/grpc/interceptors/auth/server/requireScope.ts`.
 */
import { status } from "@grpc/grpc-js";
import type { S2SAuthContext } from "../types/auth-context";
import { grpcError } from "./grpc-error";

export function requireScope(auth: S2SAuthContext | undefined, scope: string) {
  if (!auth || !auth.scopes.includes(scope)) {
    throw grpcError(
      status.PERMISSION_DENIED,
      `Missing required scope: ${scope}`,
    );
  }
}
